import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Typography } from '@/components/Typography';
import { cn } from '@/utils/cn';

interface EmptyStateProps {
  icon?: IconDefinition;
  title: string;
  description?: string;
  className?: string;
}

export const EmptyState = ({
  icon = faMagnifyingGlass,
  title,
  description,
  className,
}: EmptyStateProps) => (
  <div
    className={cn(
      'flex flex-col items-center gap-4 rounded-xl border bg-card p-10 text-center',
      className,
    )}
  >
    <div className='flex size-12 items-center justify-center rounded-full bg-primary/10 text-primary'>
      <FontAwesomeIcon icon={icon} />
    </div>
    <div className='flex flex-col gap-1'>
      <Typography variant='h4'>{title}</Typography>
      {description && (
        <Typography variant='paragraphSmall' color='muted'>
          {description}
        </Typography>
      )}
    </div>
  </div>
);
